import { styled } from 'canoe';
import React from 'react';

import { DocumentPreview } from '@candu-ai/document/preview';
import { useAuthentication } from 'commons/hooks';
import { BuiltInComponents } from 'craft/constants';
import { ContentDocument } from 'craft/types';
import { getDocumentVersionId } from 'craft/utils/viewport';

const Wrapper = styled.div<{ isSdkPreview?: boolean }>`
  position: relative;

  ${({ isSdkPreview }) =>
    !isSdkPreview &&
    `
      width: 100%;
      height: 100%;

      &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1;
      }
  `}
`;

interface PreviewFlowProps {
  stepId?: string;
  stateId?: string;
  isSdkPreview?: boolean;
  stepNodeId?: string;
}

export const PreviewFlow = React.memo(
  ({ stepNodeId, stepId, stateId, isSdkPreview }: PreviewFlowProps) => {
    const { applicationId } = useAuthentication();
    const versionId = getDocumentVersionId();
    if (!versionId) {
      return null;
    }
    const findRootNodeId = (document: ContentDocument) => {
      const pair =
        Object.entries(document.nodes).find(
          (keys) =>
            (stepId && keys[1]?.props?.stepId === stepId) ||
            (stateId && keys[1]?.props?.stateId === stateId),
        ) || [];

      return pair[0];
    };

    if (isSdkPreview || !stepNodeId) {
      return (
        <Wrapper isSdkPreview={isSdkPreview}>
          <DocumentPreview
            applicationId={applicationId}
            versionId={versionId}
            findRootNodeId={findRootNodeId}
            isSdkPreview={isSdkPreview}
          />
        </Wrapper>
      );
    }

    return (
      <Wrapper>
        <DocumentPreview
          applicationId={applicationId}
          versionId={versionId}
          rootNodeId={stepNodeId}
          rootNodeType={BuiltInComponents.FlowStep}
        />
      </Wrapper>
    );
  },
);
